import { computed } from 'vue';
import { useStockVO } from '@/rebuild/hooks/useStockVO';
import i18n, { ZH } from '@/locales';

/**
 * 获取市场类型对应的 CSS 变量集合
 * 返回可直接用于 :style 绑定的 CSS 变量对象
 */
export const useMarketColors = () => {
	const { isHKStock, isUSStock } = useStockVO();

	// 市场颜色配置
	const MARKET_COLORS = {
		SH_SZ: {
			color: '#f23d3d' // 沪深股：红色
		},
		HK: {
			color: 'rgb(150, 115, 255)' // 港股：紫色
		},
		US: {
			color: 'rgb(57, 100, 229)' // 美股：蓝色
		}
	};

	/**
	 * 获取当前市场类型
	 */
	const getCurrentMarketType = computed(() => {
		if (isHKStock.value) return 'HK';
		if (isUSStock.value) return 'US';
		return 'SH_SZ';
	});

	/**
	 * 获取市场 CSS 变量集合，可直接用于 :style 绑定
	 */
	const getMarketColorVars = computed(() => {
		const config = MARKET_COLORS[getCurrentMarketType.value];
		return {
			'--market-primary-color': config.color
		};
	});

	/**
	 * 获取涨跌颜色变量
	 */
	const getTrendColorVars = computed(() => {
		// 涨跌颜色配置
		const TREND_COLORS = {
			up: '#f23d3d', // 涨：红色
			down: '#30bf54' // 跌：绿色
		};
		// TODO 可能要按照上市市场来判断
		// 根据语言环境判断颜色逻辑，中文环境：涨红跌绿，非中文环境：涨绿跌红
		return {
			'--market-trend-color--up': i18n.locale === ZH ? TREND_COLORS['up'] : TREND_COLORS['down'],
			'--market-trend-color--down': i18n.locale === ZH ? TREND_COLORS['down'] : TREND_COLORS['up']
		};
	});

	return {
		getMarketColorVars,
		getTrendColorVars
	};
};
